import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';
import {
  AssayDevelopmentStudyState,
  StudySchema,
  TypedStudyAdapter,
} from 'studies/typed/utils/TypedStudyTypes';

import MultiProcedureRunAndPlanOverviewTabContents from '../shared/MultiProcedureRunAndPlanOverviewTabContents';
import MultiProcedureRunOverviewTabContents from '../shared/MultiProcedureRunOverviewTabContents';
import ProcedureRunAndPlanOverview from '../shared/ProcedureRunAndPlanOverview';
import ProcedureRunOverview from '../shared/ProcedureRunOverview';

export const ProcessDevelopmentStudyAdapter: TypedStudyAdapter<never, AssayDevelopmentStudyState> = {
  type: StudyType.PROCESS_DEVELOPMENT,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: true,

  isMultiConditionEnabled: true,

  isNotificationSchedulesEnabled: true,

  isUnitOperationInstanceLinkingEnabled: true,

  isVisualizationEnabled: true,

  isOOTBChartingEnabled: true,

  allowReturnToDesignPhase: false,

  allowRequireDesignApproval: false,

  renderMetadataSection(_state: AssayDevelopmentStudyState) {
    return <></>;
  },

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },
  creation: {},
  design: {
    ui: {
      tab: null,
    },
  },
  overview: {
    ui: {
      tab: BenchlingConfig.STUDIES_ENABLE_PROCEDURE_RUN_DESIGN
        ? MultiProcedureRunAndPlanOverviewTabContents
        : MultiProcedureRunOverviewTabContents,
      design: null,
      execution: BenchlingConfig.STUDIES_ENABLE_PROCEDURE_RUN_DESIGN
        ? ProcedureRunAndPlanOverview
        : ProcedureRunOverview,
    },
  },
  review: {},
};
